export default __webpack_public_path__ + "static/per-marker-customisation-401d7aa2db56a0fff4b97ab72b6953aa.png";